import palette from '../../theme/palette';

const customDataGridStyle = ((theme) => ({
  customDataGrid: {
    maxWidth: '100%',
    '.MuiDataGrid-root': {
      outline: 'none !important',
      border: 'none !important',
    },
    '& .MuiDialogContent-root': {
      overflow: 'visible',
    },

    '&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
      visibility: 'visible',
    },

    '& .MuiDataGrid-virtualScroller': {
      overflow: 'auto !important',

      '&::-webkit-scrollbar-thumb': {
        visibility: 'hidden',
        backgroundColor: palette.primary.main,
        borderRadius: '4px',
      },
    },

    '& .MuiDataGrid-columnHeaders': {
      borderTop: 'none',
      fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
      fontWeight: 'bold',
    },
    '& .MuiDataGrid-iconSeparator': {
      visibility: 'hidden',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
      color: theme.palette.secondary.mainColor,
    },
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle:focus': {
      outline: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
    },
    '& .MuiDataGrid-cell': {
      textAlign: 'left',
      border: 'none !important',
      padding: '10px',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
      outlineOffset: 0,
    },
  },
  centreAlign: {
    '& .MuiDataGrid-iconButtonContainer': {
      visibility: 'visible',
      width: '0 !important',
    },
  },
  clickableRow: {
    '& .MuiDataGrid-row:hover': {
      cursor: 'pointer',
    },
  },
}));

export default customDataGridStyle;
